import { omit } from 'lodash';

export const getFullName = (firstName, lastName) => {
  return `${firstName ?? null} ${lastName ?? null}`.trim();
};

export const sanitizePolygraphy = (polygraphy) =>
  omit(polygraphy, ['currentPaymentStatus', 'currentPaymentAmount']);

export const sanitizePolysomnography = (polysomnography) =>
  omit(polysomnography, ['currentPaymentStatus', 'currentPaymentAmount']);

export const sanitizeTeleconsultation = (tc) =>
  omit(tc, [
    'currentPaymentStatus',
    'currentPaymentAmount',
    'eventCancellationReason',
    'cancelled',
    'cancelledAt',
    'cancelledBy',
  ]);
